import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppLayoutComponent],
  template: '<app-layout />',
})
export class App {}
